var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M246,235.6L246,235.6C246,235.6,246,235.6,246,235.6c0-1-0.2-2-0.5-2.9c-8.4-41.8-38.5-75.7-78-89.4c19.7-12.9,32.7-35.1,32.7-60.4c0-39.9-32.3-72.2-72.2-72.2c-39.9,0-72.2,32.3-72.2,72.2c0,25.3,13,47.5,32.7,60.4c-39.5,13.8-69.6,47.7-78,89.4c-0.3,0.9-0.5,1.9-0.5,2.8c0,0,0,0,0,0l0,0c0,0.1,0,0.2,0,0.3c0,5.2,4.2,9.4,9.4,9.4s9.4-4.2,9.4-9.4c0-0.1,0-0.2,0-0.3h0.2c9.6-45.9,50.2-80.3,98.9-80.3c48.7,0,89.4,34.4,98.9,80.3h0.2c0,0.1,0,0.2,0,0.3c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4C246,235.8,246,235.7,246,235.6z M74.2,82.8c0-29.7,24.1-53.8,53.8-53.8c29.7,0,53.8,24.1,53.8,53.8s-24.1,53.8-53.8,53.8C98.3,136.6,74.2,112.5,74.2,82.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.c8b2346c8d5f54b6866e2cbeccd91ead.svg";
export { ForwardRef as ReactComponent };